<template>
  <div class="hot-tabs clearfix" ref="content">
    <template>
    <el-tabs v-model="active_index">
      <template v-for="(item, index) in tab_data">
        <el-tab-pane :label="item.title" :name="JSON.stringify(index)" :key="index" @click="active_index = JSON.stringify(index)">
          <div
          v-html="re_remover_class(item.content)"
          class="tinymce-content page_text_font default_css"
          ></div>
        </el-tab-pane>
      </template>
    </el-tabs>
  </template>
  </div>
</template>

<script>
export default {
  props: ['tab_data'],
  data() {
    return {
      category_all: [],
      active_index: null,
      products: [],
    }
  },
  methods: {
    addIframeDiv() {
      this.$nextTick(() => {
        const dom = this.$refs.content
        const iframes = this.$(dom).find('iframe')
        if (iframes.length > 0) {
          iframes.each((index) => {
            this.$(iframes[index])?.wrapAll('<div class="detail-iframe-wrapper"></div>')
          })
        }
      })
    },
  },
  beforeMount() {
    this.active_index = '0'
  },
  mounted() {},
  watch: {
    tab_data(newV) {
      if (newV?.length > 0) {
        newV.forEach((item, index) => {
          if (item.type == 'describe') {
            this.active_index = JSON.stringify(index)
          }
          this.addIframeDiv()
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hot-tabs {
  &::v-deep {
   .el-tabs {
      &__item {
        font-family: var(--title-font-family);
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 5px;
        letter-spacing: 2px;
        &.is-active {
          color: #000;
        }
        &:hover {
          color: #000;
        }
      }
      &__active-bar {
        background-color: #000;
      }
    }
  }
}
@media (max-width: 767px) {
  .hot-tabs {
    &::v-deep {
      .el-tabs {
        &__item {
          font-size: 13px;
        }
        &__nav-prev {
          display: none;
        }
        &__nav-next {
          display: none;
        }
        &__nav-scroll {
          overflow-x: scroll;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        &__nav {
          transform: none !important;
        }
      }
   }
  }
}
</style>
